import React from 'react';
import { X, Youtube, Music, Headphones } from 'lucide-react';
import { siteConfig } from '../mockData';
import './ListenModal.css';

export const ListenModal = ({ isOpen, onClose, episode }) => {
  if (!isOpen || !episode) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content">
        <button className="modal-close" onClick={onClose} aria-label="Close modal">
          <X size={24} />
        </button>
        
        <div className="modal-header">
          <h2 className="heading-2">Choose Where to Listen</h2>
          <p className="body-medium modal-episode-title">{episode.title}</p>
        </div>
        
        <div className="modal-options">
          <a 
            href={`https://www.youtube.com/watch?v=${episode.youtubeId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="listen-option youtube-option"
          >
            <div className="option-icon youtube-icon">
              <Youtube size={32} />
            </div>
            <div className="option-content">
              <h3 className="option-title">Watch on YouTube</h3>
              <p className="option-description">Full video episode with visuals</p>
            </div>
          </a>
          
          <a 
            href={siteConfig.podcast.spotify}
            target="_blank"
            rel="noopener noreferrer"
            className="listen-option spotify-option"
          >
            <div className="option-icon spotify-icon">
              <Music size={32} />
            </div>
            <div className="option-content">
              <h3 className="option-title">Listen on Spotify</h3>
              <p className="option-description">Audio podcast on Spotify</p>
            </div>
          </a>
          
          <a 
            href={siteConfig.podcast.apple}
            target="_blank"
            rel="noopener noreferrer"
            className="listen-option apple-option"
          >
            <div className="option-icon apple-icon">
              <Headphones size={32} />
            </div>
            <div className="option-content">
              <h3 className="option-title">Listen on Apple Podcasts</h3>
              <p className="option-description">Audio podcast on Apple Podcasts</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};
